export default "__VITE_ASSET__DIedwAbZ__"